var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.441.416c.168 0 .334.036.486.105.152.07.286.17.392.296l5.433 6.5c.166.194.256.437.256.688 0 .251-.09.494-.256.688l-5.625 6.5a1.156 1.156 0 01-1.586.14 1.058 1.058 0 01-.146-1.527L5.424 8 .564 2.193a1.048 1.048 0 01-.152-1.159C.504.848.65.69.832.58c.183-.11.394-.166.61-.164z"
  })));
}

export default SvgPaginationArrow;